import React, { useEffect, useContext, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { getItemsAvailabilities } from '../../../../../queries';
import { HeaderDynamicContext } from '../../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import { updateStoreInfoForCart } from '../../../../../graphql/mutation';
import FindStore from './FindStore';
import { analyze } from '../../../../../helpers';

function FindStoreVM(props) {
  const {
    customer, customerStore, orderSummary, heartBeatData, setCustomerStore,
  } = useContext(HeaderDynamicContext);

  const { preferredStore, loginStatus, postalCode } = customer ?? {};
  const { lineItems } = orderSummary?.orderSummary ?? {};
  const [zipCode, setZipCode] = useState(postalCode || '');

  const triggerAnalyze = (data) => {
    analyze({
      name: 'storeSearch',
      data: {
        zipCode,
        nearByStores : data,
      },
    });
  }

  const [
    fetchNearbyStores,
    {
      loading,
      error: nearByStoreErr,
      data: nearByStores,
    }] = useLazyQuery(getItemsAvailabilities, {
      onCompleted: triggerAnalyze
    });
  

  const [updateStoreInCart] = useMutation(updateStoreInfoForCart, {
    onCompleted(response) {
      try {
        const customerStoreInfo = response?.updateStoreInfoForCart?.customerStoreInfo?.orderStore
        || {};
        if (customerStoreInfo?.storeId) setCustomerStore(customerStoreInfo);
        window.Heartbeat.beat();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error trying to update header selected store: ', error);
      }
    },
  });

  useEffect(() => {
    if (customerStore?.postalCode) {
      fetchNearbyStores({
        variables: {
          zipcode: customerStore?.postalCode,
        },
      });
    }
  }, [customerStore, fetchNearbyStores]);

  const mapProps = {
    ...props,
    customerStore,
    getNearByStores: fetchNearbyStores,
    heartBeatData,
    isLoggedIn: loginStatus,
    lineItems,
    nearByStores: nearByStoreErr ? []
    : nearByStores
      ?.itemsAvailabilities
      ?.filter(({ storeId }) => storeId !== customerStore?.storeId),
    preferredStore,
    setZipCode,
    storeLoading: loading,
    updateStoreInCart,
    zipCode,
  };

  return <FindStore {...mapProps} />;
}

export default FindStoreVM;
